module.exports = __webpack_public_path__ + "static/media/cow.91164911.png";